import http from "./http";

export const fetchInvestmentData = () => http.get("/users/investments/types");
export const fetchPortfolioData = () => http.get("/users/investments/portfolio");
export const investInProduct = (credentials) => {return http.post("/users/investments/order/invest", credentials);}
export const fetchPortfolioItem = (id) => http.get(`/users/investments/portfolio/items/${id}`)
export const fetchGroupedProduct = () => http.get(`/users/investments/grouped`)